// Ürün API çağrıları tek bir yerde toplandı.
// Backend uçları: GET /products, GET /product/:id, POST /add-product,
// PUT /product (id body içinde), DELETE /product/:id
import { API_BASE } from "../config";

const jsonHeaders = { "Content-Type": "application/json" };

// Backend hata gövdesi { message } (veya { error, message }) biçiminde döner.
const handleResponse = async (response, fallbackMessage) => {
	let body = null;
	try {
		body = await response.json();
	} catch (_) {
		body = null;
	}
	if (!response.ok) {
		const error = new Error(body?.message || fallbackMessage);
		error.status = response.status;
		throw error;
	}
	return body;
};

export const getProducts = async () => {
	const response = await fetch(`${API_BASE}/products`);
	return handleResponse(response, "Ürünler getirilemedi");
};

export const getProduct = async (id) => {
	const response = await fetch(`${API_BASE}/product/${id}`);
	return handleResponse(response, "Ürün bulunamadı");
};

export const addProduct = async (product) => {
	const response = await fetch(`${API_BASE}/add-product`, {
		method: "POST",
		headers: jsonHeaders,
		body: JSON.stringify(product),
	});
	return handleResponse(response, "Ürün eklenemedi");
};

export const updateProduct = async (id, product) => {
	const response = await fetch(`${API_BASE}/product`, {
		method: "PUT",
		headers: jsonHeaders,
		body: JSON.stringify({ id, ...product }),
	});
	return handleResponse(response, "Ürün güncellenemedi");
};

export const deleteProduct = async (id) => {
	const response = await fetch(`${API_BASE}/product/${id}`, {
		method: "DELETE",
	});
	return handleResponse(response, "Ürün silinemedi");
};
